import React, { PropsWithChildren, useContext } from 'react';
import classNames from 'classnames';
import SRBadge from '~/components/atoms/srBadge/srBadge';
import Header from '~/components/organisms/header/header';
import { UpdateSearchQuery } from '~/core/useSearchState';
import { LogoClickProperties } from '~/hooks/useLogoClickHandler';
import { CloseSERP } from '~/hooks/useShowSearch';
import { FilterVisibilityContext } from '../main';
import ScrollToTopButton from '../molecules/scrollToTopButton/ScrollToTopButton';
import styles from './layout.modules.scss';

export interface ISERPLayoutProps {
    logoURL: string;
    logoClickProperties: LogoClickProperties;
    showSERPContent: boolean;
    searchQuery: string;
    updateSearchQuery: UpdateSearchQuery;
    closeSERP: CloseSERP;
    innerSERPRef: React.RefObject<HTMLDivElement>;
    autofocus: boolean;
}

const Layout: React.FC<PropsWithChildren<ISERPLayoutProps>> = ({
    logoURL,
    logoClickProperties,
    showSERPContent,
    searchQuery,
    updateSearchQuery,
    closeSERP,
    children,
    innerSERPRef,
    autofocus,
}) => {
    const headerRef = React.useRef<HTMLDivElement>(null);
    const { isLayoutOverflowHidden } = useContext(FilterVisibilityContext);

    return (
        <div className={classNames(styles.serpOverlay)}>
            <div
                className={classNames(styles.serpPage, 'serp-page')}
                ref={innerSERPRef}
                style={isLayoutOverflowHidden ? { overflow: 'hidden' } : { overflow: 'auto' }}
            >
                <Header
                    updateSearchQuery={updateSearchQuery}
                    searchQuery={searchQuery}
                    closeSERP={closeSERP}
                    logoURL={logoURL}
                    logoClickProperties={logoClickProperties}
                    headerRef={headerRef}
                    autofocus={autofocus}
                />
                <div
                    className={classNames(styles.serpContentWrapper, !showSERPContent ? styles.empty : '')}
                    data-testid="content-wrapper"
                >
                    {children}
                    <SRBadge />
                    <ScrollToTopButton headerRef={headerRef} showSERPContent={showSERPContent} />
                </div>
            </div>
        </div>
    );
};

export default Layout;
